import React,{useState} from 'react'
import {
	useSelector,
	useDispatch
} from 'react-redux'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'
import {updateNutrtionSimplifiedFood} from '../todaysEvents/TodaysEventsSlice'
import classes from './SimplifiedNutrition.module.css'

const AmountSelector = ({icon,nutrition_id,foodData}) =>{
	const dispatch = useDispatch()
	const {id:food_id} = foodData
	const {quantity} = foodData
	const [completed,setCompleted] = useState(foodData.completed)
	const wholeCount = Math.floor(completed)
	const quarterAmount = completed-wholeCount

	const getWidthPercent = (completed,idx)=>{
		return Math.max(Math.min(completed - idx,1),0)*100
	}
	const dispatchUpdate = (completed,id)=>{
		dispatch(updateNutrtionSimplifiedFood({
			completed, id, nutrition_id
		}))
	}
	const completedOptions = [
		{
			text:'1/4',
			amount:1/4
		},{
			text:'1/3',
			amount:1/3
		},{
			text:'1/2',
			amount:1/2
		},{
			text:'2/3',
			amount:2/3
		},{
			text:'3/4',
			amount:3/4
		},{
			text:'1',
			amount:1
		},
	]
	return (
		<div>
			{[...Array(quantity)].map((_,i)=>(
				<OverlayTrigger rootClose key={i} trigger="click" overlay={
					<Popover>
						<Popover.Content>
							<ButtonGroup>
								{completedOptions.map(opt=>(
									<Button onClick={()=>{
										const newCompleted = completed+opt.amount
										dispatchUpdate(newCompleted,food_id)
										setCompleted(newCompleted)
									}} variant="outline-primary" size="sm">{opt.text}</Button>
								))}
							</ButtonGroup>
						</Popover.Content>
					</Popover>
				}>
					<button 
						className={[
							"m-1 shadow",
							classes.CompletionOrb
						].join(' ')}>
						<div style={{
							left:0,
							top:0,
							position:'absolute',
							height:'100%',
							width:`${getWidthPercent(completed,i)}%`,
							backgroundColor:'#00ff8c'
						}} />
						<img style={{maxHeight:'70%',maxWidth:'70%',position:'relative',zIndex:'2'}} src={icon}/>
					</button>
				</OverlayTrigger>
			))}
		</div>
	)
}

const BasicNutrition = props => {
	const url = new URL(window.location.href)
	const params = new URLSearchParams(url.search);
	const nutrition_id = parseInt(params.get('nutrition_id'))
	const nutritionData = useSelector(state=>state.allEvents.nutrition.entities[nutrition_id])
	const iconMap = {
		protein:"fish.svg",
		carbs:"carbs.svg",
		carbohydrates:"carbs.svg",
		healthyFat:"avocado.svg",
		'healthy fat':"avocado.svg",
		fruit:"apple.svg",
		vegetables:"broccoli.svg",
		water:"beverage.svg"
	}
	const path = window.location.host === 'localhost:3000' ? '/icons/food/svg/' : '/assets/img/icons/food/svg/'
	if(!nutritionData) return null
	return (
		<div className="d-flex justify-content-center">
			<div className="m-3 p-4 rounded shadow" style={{background:'#00041c',maxWidth:'800px'}}>
				<div className="d-flex align-items-center">
					<img style={{
						height:'40px',
						width:'40px',
						margin:'4px',
						background:'#eee',
						borderRadius:'100%'
					}} src={`${path}/health.svg`}/>
					<h2 className="m-0" style={{color:'#eee'}}>{nutritionData.title}</h2>
				</div>
				<p style={{color:'#eee',whiteSpace:'pre-line'}}>{nutritionData.notes}</p>
				<hr className="my-1 bg-secondary"/>
				{nutritionData.simplified_food.map(food=>(
					<div>
						<div style={{color:'#eee'}}>{food.name}</div>
						<AmountSelector
							nutrition_id={nutrition_id}
							foodData={food}
							icon={`${path}${iconMap[food.name]}`}/>
					</div>
				))}
			</div>
		</div>
	)
}

export default BasicNutrition